export default "__VITE_ASSET__DGf$kb9d__"